import { render } from "./ProgramBenefits.vue?vue&type=template&id=226730b6"
import script from "./ProgramBenefits.vue?vue&type=script&lang=js"
export * from "./ProgramBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__